module.exports = __webpack_public_path__ + "img/empty.5d7ed83e.png";